import { templateStepIndex } from "./guided-template";

export type UgcMode = "talking" | "product";
export type UgcStage = "product" | "person" | "speech";

export function ugcStepIndex(mode: UgcMode, stage: UgcStage, reviewing: boolean): number {
  if (reviewing) return 2;
  return mode === "product" ? (stage === "product" ? 0 : 1) : (stage === "speech" ? 1 : 0);
}

export function restoreUgcMode(value: unknown): UgcMode {
  return value === "product" ? "product" : "talking";
}

export function hasProductInput(url: string, description: string, mediaCount: number): boolean {
  return Boolean(url.trim() || description.trim() || mediaCount > 0);
}

export function draftStepLabel(step: number, payload: Record<string, unknown>): string {
  if ((!payload.style && payload.ugcMode) || payload.style === "infinitetalk_avatar" || payload.style === "ugc" || payload.style === "spokesperson" || payload.style === "clone_creator") {
    const mode = restoreUgcMode(payload.ugcMode);
    const stage = payload.ugcStage === "product" || payload.ugcStage === "speech" ? payload.ugcStage : "person";
    return `Step ${ugcStepIndex(mode, stage, step > 0) + 1}/3`;
  }
  return `Step ${templateStepIndex(step) + 1}/3`;
}
